import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IGetOSQueryParams,
  IGetOsDetalheQueryParams,
  IGetUltimaOSCadastradaEspecificoQueryParams,
  IListaPaginada,
  IOS,
  IOSAndamento,
  IOSFinalizada,
  IOsDetalhe,
  IPostOSBody,
  ITecnico
} from 'src/app/interfaces';
import { IAtendente } from 'src/app/interfaces/atendente';
import { IPostOSAtendenteBody } from 'src/app/interfaces/os/IPostOSAtendenteBody';
import { IPostOSTecnicoBody } from 'src/app/interfaces/os/IPostOSTecnicoBody';
import { IParceiro } from '../parceiro';
import { OSDetalhada } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class OSService {
  private readonly baseURL = '/OS';
  constructor(private httpClient: HttpClient) {}

  getOS(body: IGetOSQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IOS>>>(
      `${this.baseURL}/ObterOrdemServico`,
      body
    );
  }

  getOSAndamento(body: IGetOSQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IOSAndamento>>>(
      `${this.baseURL}/Andamento`,
      body
    );
  }

  getUltimaOSCadastradaEspecifico(
    body: IGetUltimaOSCadastradaEspecificoQueryParams
  ) {
    return this.httpClient.post<IApiResponse<OSDetalhada>>(
      `${this.baseURL}/UltimaOSCadastradaEspecifico`,
      body
    );
  }

  getOSFinalizada(body: IGetOSQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IOSFinalizada>>>(
      `${this.baseURL}/Finalizada`,
      body
    );
  }

  getOSDetalhe(body: IGetOsDetalheQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IOsDetalhe>>>(
      `${this.baseURL}/Detalhe`,
      body
    );
  }

  postOS(body: IPostOSBody) {
    return this.httpClient.post<IApiResponse<string>>(this.baseURL, body);
  }

  postOSTecnico(body: IPostOSTecnicoBody) {
    return this.httpClient.post<IApiResponse<ITecnico[]>>(
      `${this.baseURL}/atribuirTecnico`,
      body
    );
  }

  postOSParceiro(body: IPostOSTecnicoBody) {
    return this.httpClient.post<IApiResponse<IParceiro[]>>(
      `${this.baseURL}/atribuirParceiro`,
      body
    );
  }

  postOSAtendente(body: IPostOSAtendenteBody) {
    return this.httpClient.post<IApiResponse<IAtendente[]>>(
      `${this.baseURL}/atribuirAtendente`,
      body
    );
  }
}
